import { render } from "./BuildConfigure.vue?vue&type=template&id=b4a8ea00&scoped=true"
import script from "./BuildConfigure.vue?vue&type=script&lang=js"
export * from "./BuildConfigure.vue?vue&type=script&lang=js"

import "./BuildConfigure.vue?vue&type=style&index=0&id=b4a8ea00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4a8ea00"]])

export default __exports__